import { render, staticRenderFns } from "./VideoMonitor.vue?vue&type=template&id=4136d064&scoped=true&"
import script from "./VideoMonitor.vue?vue&type=script&lang=js&"
export * from "./VideoMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4136d064",
  null
  
)

export default component.exports